import { BehavioralInsightPresentationMode, EventTypes } from 'modules/domains/segmentation';
import { useContext, createContext } from 'react';
import noop from 'utils/noop';
import { CustomBehavioralInsight, BehavioralEvent } from '../../domain';

export type CustomBehavioralContext = {
  addCustomBehavioralEvent: (
    eventName: string,
    mode: BehavioralInsightPresentationMode,
    dataType: EventTypes,
  ) => void;
  deleteCustomBehavioralEvent: (eventName: string, dataType: EventTypes) => void;
  cachedCustomBehavioralInsights: CustomBehavioralInsight[];
  selectableEventsForProject: BehavioralEvent[];
  allCustomEvents: BehavioralEvent[];
  allStandardEvents: BehavioralEvent[];
  maxBehavioralInsightSettingsForProject: number;
};

export const customBehavioralDefaultState = {
  addCustomBehavioralEvent: noop,
  deleteCustomBehavioralEvent: noop,
  cachedCustomBehavioralInsights: [],
  selectableEventsForProject: [],
  allCustomEvents: [],
  allStandardEvents: [],
  maxBehavioralInsightSettingsForProject: 0,
};

export const CustomBehavioralContext = createContext<CustomBehavioralContext>(
  customBehavioralDefaultState,
);
export const useCustomBehavioralContext = () => useContext(CustomBehavioralContext);
